module.exports = __webpack_public_path__ + "static/img/shiseido_s.bb9090f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/shiseido_s.jpg
// module id = ksur
// module chunks = 23